import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  confirmedModifiedSustantial: boolean | null;
  proceedModification: boolean | null;
  countTextArea: number;
  rejectionJustification: string;
  onConfirmedModifiedSustantialChange?: (value: boolean | null) => void;
  onProceedModificationChange?: (value: boolean | null) => void;
  onCountTextAreaChange?: (value: number) => void;
  onRejectionJustificationChange?: (value: string) => void;
};

const AccordanceDecisionSection = ({
  confirmedModifiedSustantial,
  proceedModification,
  countTextArea,
  rejectionJustification,
  onConfirmedModifiedSustantialChange,
  onProceedModificationChange,
  onCountTextAreaChange,
  onRejectionJustificationChange,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div className="accordance-detail-decision-section">
      <div className="accordance-detail-question-block">
        <p className="decision-modification-title">{t('decision_modification').toUpperCase()}</p>
        <p className="decision-modification-text">{t('classify_modification')}</p>
      </div>

      <div className="accordance-detail-confirmed-block">
        <p className="accordance-detail-question-text">{t('confirm_modification')}</p>

        <div className="mt-1">
          <input
            type="radio"
            name="confirmedModifiedSustantial"
            checked={confirmedModifiedSustantial === true}
            onChange={() => onConfirmedModifiedSustantialChange?.(true)}
          />
          <span>{t('yes')}</span>
        </div>

        <div className="mt-1">
          <input
            type="radio"
            name="confirmedModifiedSustantial"
            checked={confirmedModifiedSustantial === false}
            onChange={() => onConfirmedModifiedSustantialChange?.(false)}
          />
          <span>{t('no')}</span>
        </div>
      </div>

      {confirmedModifiedSustantial === true && (
        <div className="accordance-detail-question-block">
          <p className="accordance-detail-question-text">{t('confirm_proceed')}</p>

          <div className="mt-1">
            <input
              type="radio"
              name="proceedModification"
              checked={proceedModification === true}
              onChange={() => onProceedModificationChange?.(true)}
            />
            <span>{t('yes')}</span>
          </div>

          <div className="mt-1">
            <input
              type="radio"
              name="proceedModification"
              checked={proceedModification === false}
              onChange={() => onProceedModificationChange?.(false)}
            />
            <span>{t('no')}</span>
          </div>
        </div>
      )}

      {(confirmedModifiedSustantial === false || proceedModification === false) && (
        <>
          <div className="accordance-detail-required-header">
            <div className="accordance-detail-justification-text">
              <p className="accordance-detail-question-text">{t('justification_rejection')}</p>
              <span className="accordance-detail-required-label">({t('efas_pending_states_10')})</span>
            </div>
            <div>
              <p className="accordance-detail-required-label">{250 - countTextArea}</p>
            </div>
          </div>

          <textarea
            className="accordance-detail-rejection-textarea"
            rows={3}
            maxLength={250}
            onChange={e => {
              const value = e.target.value;
              onCountTextAreaChange?.(value.length);
              onRejectionJustificationChange?.(value);
            }}
            value={rejectionJustification}
          ></textarea>
        </>
      )}
    </div>
  );
};

export default AccordanceDecisionSection;
